import React from "react";

import {connect} from "react-redux";
import {
    threadsSearchData, threadsSearchErrorSelector,
    threadsSearchHasNext,
    threadsSearchNextLoading
} from "features/pages/threads/search/selectors";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Button from "features/components/button";
import {startThreadsSearch, threadsSearchFetchNextPage} from "features/pages/threads/search/reducer";
import ThreadCard from "features/components/thread-card";
import {useMediaQuery} from "services/utils/utils";
import {MOBILE_MEDIA_QUERY_THRESHOLD} from "constants.js";

/* istanbul ignore next */
const mapStateToProps = state => ({
    data: threadsSearchData(state),
    next_loading: threadsSearchNextLoading(state),
    has_next_page: threadsSearchHasNext(state),
    error: threadsSearchErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    threadsSearchFetchNextPage,
    startThreadsSearch
};

export const ThreadSearchResults = (props) => {
    const {data, has_next_page, next_loading, error} = props;
    const {threadsSearchFetchNextPage, startThreadsSearch} = props;

    React.useEffect(() => {
        startThreadsSearch();
    }, [startThreadsSearch]);

    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD);

    const items = data.threads;
    return <div className="home-section">
        <Title size={34}>{__("threads.titles.all")}</Title>
        {error.inError && <Text size={16} color={"danger"}>{__(error.error)}</Text>}
        {
            !items.length ?
                <Text size={16} align={"center"}>{__("threads.no-results")}</Text> :
                <>
                    <div className="threads-list active">
                        {
                            items.map(item => <ThreadCard key={item.id} item={item} type={isMobile ? "small" : "default"} />)
                        }
                    </div>
                    {has_next_page && <div className="row next">
                        <Button title={__("buttons.load-more")}
                                onClick={threadsSearchFetchNextPage}
                                type={"outlined"}
                                status={next_loading ? "loading" : null}
                        />
                    </div>}
                </>
        }
    </div>
}

export default connect(mapStateToProps, mapDispatchToProps)(ThreadSearchResults);